import '../charts';
import {initFlowbite} from 'flowbite';
import lightGallery from 'lightgallery';
import lgThumbnail from 'lightgallery/plugins/thumbnail'
import lgZoom from 'lightgallery/plugins/zoom';
import __ from 'lodash';
import './handle';
import 'lightgallery/css/lightgallery.css';
import 'lightgallery/css/lg-zoom.css';
import 'lightgallery/css/lg-thumbnail.css';

window.onload = () => {
    initFlowbite();

    const clipboardTelegram = FlowbiteInstances.getInstance('CopyClipboard', 'telegram');
    const clipboardFacebook = FlowbiteInstances.getInstance('CopyClipboard', 'facebook');
    const clipboardWhatsapp = FlowbiteInstances.getInstance('CopyClipboard', 'whatsapp');
    const clipboardViber = FlowbiteInstances.getInstance('CopyClipboard', 'viber');

    const clipboards = [
        {
            clipboard: clipboardTelegram,
            defaultMessage: document.getElementById('default-message-telegram'),
            successMessage: document.getElementById('success-message-telegram'),
        },
        {
            clipboard: clipboardFacebook,
            defaultMessage: document.getElementById('default-message-facebook'),
            successMessage: document.getElementById('success-message-facebook'),
        },
        {
            clipboard: clipboardWhatsapp,
            defaultMessage: document.getElementById('default-message-whatsapp'),
            successMessage: document.getElementById('success-message-whatsapp'),
        },
        {
            clipboard: clipboardViber,
            defaultMessage: document.getElementById('default-message-viber'),
            successMessage: document.getElementById('success-message-viber'),
        }
    ];

    clipboards.forEach((item) => {
        item.clipboard.updateOnCopyCallback(() => {
            showSuccess(item.defaultMessage, item.successMessage);

            setTimeout(() => {
                resetToDefault(item.defaultMessage, item.successMessage);
            }, 2000);
        });
    });

    const showSuccess = (defaultEl, successEl) => {
        defaultEl.classList.add('hidden');
        successEl.classList.remove('hidden');
    };

    const resetToDefault = (defaultEl, successEl) => {
        defaultEl.classList.remove('hidden');
        successEl.classList.add('hidden');
    };

};

const showMap = document.getElementById('show-map');
let map;
let marker;

window.initMap = () => {
    const position = {
        lat: parseFloat(showMap.getAttribute('data-lat')),
        lng: parseFloat(showMap.getAttribute('data-lng')),
    };
    map = new google.maps.Map(document.getElementById("map"), {
        center: position,
        zoom: 18,
        mapTypeId: google.maps.MapTypeId.SATELLITE,
    });

    marker = new google.maps.Marker({
        position: position,
        map,
        title: __('Map').toString(),
    });
};

if (showMap) {
    showMap.addEventListener('click', (e) => {
        e.preventDefault();
        const target = e.currentTarget;
        const position = {
            lat: parseFloat(target.dataset.lat),
            lng: parseFloat(target.dataset.lng),
        };
        if (map && marker) {
            marker.setPosition(position);
        } else {
            initMap();
        }
    });
}

lightGallery(document.getElementById('lb-gallery'), {
    plugins: [lgZoom, lgThumbnail],
    speed: 500,
});
